import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Tennessee = () => {
  return (
    <StatePropertyTaxPage
      stateName="Tennessee"
      processDescription="Property owners may appeal their assessment by filing with the local board of equalization during the specified appeal period, typically in May. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="March"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in March, allowing property owners time to prepare for the May appeal period."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Tennessee assesses property as of January 1 each year. This assessment date captures the property's market value and condition at the beginning of each calendar year."
      deadlineExplanation="Property owners typically have until the end of May to file appeals with the local board of equalization. The exact dates are set by each county but generally fall within May."
    />
  );
};

export default Tennessee;